module.exports = __webpack_public_path__ + "img/2.af51e70b.jpg";